import { render, staticRenderFns } from "./historicalOrders.vue?vue&type=template&id=6c85f974&scoped=true"
import script from "./historicalOrders.vue?vue&type=script&lang=js"
export * from "./historicalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85f974",
  null
  
)

export default component.exports